import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (user) {
    // Normalize roles - handles undefined, string[], or {authority}[] 
    const roles = Array.isArray(user.roles)
      ? user.roles.map(r => (typeof r === "string" ? r : r.authority ?? r.role ?? ""))
      : [];

    if (roles.includes("ROLE_ADMIN"))      return <Navigate to="/admin" replace />;
    if (roles.includes("ROLE_AGENT"))      return <Navigate to="/agent" replace />;
    if (roles.includes("ROLE_PROGRAMMER")) return <Navigate to="/programmer" replace />;
    if (roles.includes("ROLE_CONTROLLER")) return <Navigate to="/admin/scan" replace />;
    if (roles.includes("ROLE_SUPPORT"))    return <Navigate to="/admin/messages" replace />;

    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;